import React, { useEffect, ReactElement } from 'react';
import LineBreak from '../line-break/line-break.component';
import TextBlock from '../text-block/text-block.component';
import FlexContainer from '../flex-container/flex-container.component';
import FormatService from '../../services/format-service';
import ChartService from '../../services/chart-service';
import useStylesChartFunnel from './chart-funnel.styles';
import './chart-funnel.styles.scss';

const ChartFunnel: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const CHART_PRECISION: number = 1;

  const {
    containerId,
    currencySign,
    chartItemList,
    totalValue,
  } = props;

  const { classes } = useStylesChartFunnel();

  useEffect((): void => {
    if (chartItemList && chartItemList.length && totalValue && totalValue > 0) {
      ChartService.createFunnelChart(
        containerId,
        chartItemList.map((chartItem: DealStatusGroup): string | null => (
          FormatService.formatComponentToHtml(
            <TextBlock>
              {chartItem.name}
              <LineBreak />
              {currencySign}
              {FormatService.formatRoundedBigNumber(chartItem.value.toString(), CHART_PRECISION)}
            </TextBlock>,
          )
        )),
      );
    }
  }, [chartItemList]);

  return (
    <FlexContainer id={containerId} className={classes.containerChartFunnel} />
  );
});

export default ChartFunnel;
